import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/digital-ocean': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504V407.9C357.8 407.9 436.8 307 397.7 199.9 383.4 160.3 351.6 128.5 311.9 114.2 204.8 75.4 103.8 154.1 103.8 255.9H8C8 93.7 164.9-32.8 335 20.3 409.2 43.6 468.6 102.7 491.6 176.9 544.8 347.2 418.6 504 256 504zM256.3 312.6H160.7V408.2H256.3V312.6zM160.7 408.2H87V481.8H160.7V408.2zM87 346.6H25.4V408.2H87V346.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/digital-ocean.js
// module id = QUIY
// module chunks = 144